/**
 * @enum {number}
 */
const CustomElementState = {
  custom: 1,
  failed: 2,
};

export default CustomElementState;



// WEBPACK FOOTER //
// ../~/pwet/~/@webcomponents/custom-elements/src/CustomElementState.js